const I18N = {
  en: {
    next: 'Next',
    listNext: 'Next',
    previous: 'Previous',
    listPrevious: 'Previous',
    previousMobile: 'Prev',
    nextPage: 'Next page',
    previousPage: 'Previous page',
    pageNumber: 'Page {#}',
    pageNumberOf: 'Page {#} of {total} of {label}',
  },
  fr: {
    next: 'Suivante',
    listNext: 'Suiv.',
    previous: 'Précédent',
    listPrevious: 'Préc.',
    previousMobile: 'Préc.',
    nextPage: 'Page suivante',
    previousPage: 'Page précédente',
    pageNumber: 'Page {#}',
    pageNumberOf: 'Page {#} sur {total} des {label}',
  },
};

export default I18N;
